export default __webpack_public_path__ + "static/bg-masthead-f16c2ada8769e989244cd09f67a76b14.jpg";